<template>
  <div id="contenedor-main-contrato-videos">
    <!-- ToolBar -->
    <tool-bar
      v-if="!$apollo.loading && !soloLectura"
      class="my-3"
      v-on:nuevoVideo="registrarNuevoVideo">
    </tool-bar>
    <!-- Loader -->
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-thead, table-tbody"
    >
    </v-skeleton-loader>
    <template v-if="getContratoVideos.length < 1">
      <v-card flat>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-alert class="mt-4" type="info"> No hay videos registrados. </v-alert>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <template v-else>
      <v-card
      flat>
      <v-card-text>
        <listado
          v-if="!$apollo.loading && getContratoVideos.length > 0"
          :soloLectura="soloLectura"
          :listadoVideos="getListadoVideos">
        </listado>
      </v-card-text>
    </v-card>
    </template>
    <!-- Agregar contrato video -->
    <v-dialog
      v-model="mostrarRegistrarVideo"
      width="600">
      <agregar-video
        :idContrato="$route.params.idContrato"
        v-on:cerrar="cerrarVentana">
      </agregar-video>
    </v-dialog>
    <!-- Editar contrato video -->
    <v-dialog
      v-model="mostrarEditarVideo"
      width="600">
      <editar-video
        v-if="esteVideo"
        :contratoVideoEditar="esteVideo"
        v-on:cerrar="cerrarVentana">
      </editar-video>
    </v-dialog>
    <!-- Borrar contrato video -->
    <v-dialog
      v-model="mostrarEliminarVideo"
      width="450">
      <eliminar-video
      v-if="esteVideo"
        :contratoVideoEliminar="esteVideo"
        v-on:cerrar="cerrarVentana">
      </eliminar-video>
    </v-dialog>
    <v-dialog
      v-model="mostrarVentanaVideo"
      width="720">
      <ver-video
        v-if="esteVideo"
        :video="esteVideo"
        v-on:cerrar="cerrarVentana">
      </ver-video>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO_VIDEOS from '@/graphql/querys/administracion/contratos/contrato/contratovideos/contratoVideos.gql';
import AgregarVideo from '@/components/administracion/contratos/contrato/contratovideos/Agregar.vue';
import EditarVideo from '@/components/administracion/contratos/contrato/contratovideos/Editar.vue';
import EliminarVideo from '@/components/administracion/contratos/contrato/contratovideos/Eliminar.vue';
import VerVideo from '@/components/administracion/contratos/contrato/contratovideos/Video.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainContratoVideos',
  props: {
    soloLectura: {
      type: Boolean,
      requiered: false,
      default: false,
    },
  },
  components: {
    ToolBar,
    Listado,
    AgregarVideo,
    EditarVideo,
    EliminarVideo,
    VerVideo,
  },
  data() {
    return {
      mostrarRegistrarVideo: false,
      mostrarEditarVideo: false,
      mostrarEliminarVideo: false,
      mostrarVentanaVideo: false,
      esteVideo: null,
    };
  },
  mounted() {
    eventBus.$on('editar-video-contrato', (video) => {
      this.esteVideo = video;
      this.mostrarEditarVideo = true;
    });
    eventBus.$on('eliminar-video-contrato', (video) => {
      this.esteVideo = video;
      this.mostrarEliminarVideo = true;
    });
    eventBus.$on('ver-video-contrato', (video) => {
      this.esteVideo = video;
      this.mostrarVentanaVideo = true;
    });
  },
  apollo: {
    contratoVideos: {
      query: CONTRATO_VIDEOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    registrarNuevoVideo() {
      this.mostrarRegistrarVideo = true;
    },
    cerrarVentana() {
      this.mostrarRegistrarVideo = false;
      this.mostrarEditarVideo = false;
      this.mostrarEliminarVideo = false;
      this.mostrarVentanaVideo = false;
      this.esteVideo = null;
    },
  },
  computed: {
    getContratoVideos() {
      if (!this.contratoVideos) return [];
      return this.contratoVideos;
    },
    getListadoVideos() {
      return this.contratoVideos.slice().sort((a, b) => a.orden - b.orden);
    },
  },
};
</script>

<style lang="scss">

</style>
